/**
 * Created by lun on 2018/08/15
 *
 * @todo 提供统一的过滤器api
 */
import Vue from 'vue';
import date from './date';

/**
 * [description] 时分秒-> 00:00:12
 * @return {[type]}      [description]
 */
Vue.filter('formatSecondsTime', function (val) {
    return date.formatDate.formatSecondsTime(val);
});


/**
 * [formatDuration 毫秒转换为 时分秒显示，例如：5天02:12:23（还未完成）]
 * @param  {[type]} val [description]
 * @return {[type]}     [description]
 */
function formatDayDuration (val) {
    if (val === undefined || val === null || val === '') {
        return '';
    }
    let date = new Date();
    let nowTime = (new Date() - new Date(val)) / 1000;
    let retArr = [];
    let second = nowTime % 60;  // 秒

    retArr.unshift(('0' + second).slice(-2));
    if (nowTime - second > 0) {
        let minute = (nowTime - second) / 60 % 60;

        retArr.unshift(('0' + minute).slice(-2));
        if (nowTime - second - minute * 60 > 0) {
            let hour = (nowTime - second - minute * 60) / 60 / 60 % 24;

            if (hour < 10) {
                retArr.unshift(('0' + hour).slice(-2));
            } else {
                retArr.unshift(('' + hour).slice(-2));
            }

            let day = (nowTime - second - minute * 60 - (hour * 60 * 60)) / 60 / 60 / 24;

            retArr.unshift((day + '天').slice(-3));
        } else {
            retArr.unshift('00');
        }
    } else {
        retArr.unshift('00');
        retArr.unshift('00');
    }

    return retArr.join(':').replace('天:', '天');
}

// setInterval(formatDuration('2018-07-27 10:52:45'), 1000);
// setInterval(function () {
//     formatDuration('2018-07-27 10:52:45');
// }, 1000);



// WEBPACK FOOTER //
// ./src/common/js/filter.js